import React, { useState } from 'react';
import { 
  Toolbar, 
  Typography, 
  MenuItem,
  useMediaQuery,
  useTheme,
  Box,
} from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  StyledAppBar,
  UserInfo,
  SystemBanner,
  UserAvatar,
  UserTextContainer,
  UserName,
  UserRole,
  StyledMenu,
} from '../../styles/Header.styles';
import MyProfile from '../MyProfile/MyProfile';

const Header = ({ pageTitle }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileOpen, setProfileOpen] = useState(false);
  const [userInfoExpanded, setUserInfoExpanded] = useState(false);
  const initials = user?.firstName?.[0] || '';

  const handleClick = (event) => {
    if (isMobile) {
      // On mobile, first click expands user info, second click opens menu
      if (!userInfoExpanded) {
        setUserInfoExpanded(true);
      } else {
        setAnchorEl(event.currentTarget);
      }
    } else {
      // On desktop, directly open menu
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    // Collapse user info on mobile when menu closes
    if (isMobile) {
      setUserInfoExpanded(false);
    }
  };

  const handleLogout = () => {
    handleClose();
    logout(() => navigate('/login'));
  };

  const handleProfileClick = () => {
    handleClose();
    setProfileOpen(true);
  };

  const handleProfileClose = () => {
    setProfileOpen(false);
  };

  return (
    <>
      <StyledAppBar position="static">
        <Toolbar>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              fontSize: isMobile ? '1.5rem' : '2.125rem', 
              fontWeight: 400,
              flexGrow: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {pageTitle}
          </Typography>
          <UserInfo onClick={handleClick}>
            <UserAvatar>
              {initials}
            </UserAvatar>
            {(!isMobile || userInfoExpanded) && (
              <UserTextContainer>
                <UserName>
                  {user?.firstName} {user?.lastName}
                </UserName>
                <UserRole>
                  {user?.title || 'User'}
                </UserRole>
              </UserTextContainer>
            )}
          </UserInfo>
          <StyledMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleProfileClick}>My Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </StyledMenu>
        </Toolbar>
      </StyledAppBar>
      <SystemBanner>
        <Typography>
          {isMobile ? (
            <>
              This system is not approved for
              <br />
              Controlled Unclassified Information (CUI)
            </>
          ) : (
            'This system is not approved for Controlled Unclassified Information (CUI)'
          )}
        </Typography>
      </SystemBanner>
      <MyProfile open={profileOpen} onClose={handleProfileClose} />
    </>
  );
};

export default Header;
